"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var downloadDetail = require("./src/driver-detail");
var common_1 = require("../psp_driverlist/src/common");
var l = require("lenovo");
// import def = require("../../../core/src/def");
// import productinfo = require("../psp_home/src/pcg.productinfo");
//import SearchBarWrapper = require('../../../core/src/common/searchbar_wrapper/SearchbarWrapper');
try {
    // if (!$(".mse-psp-info").hasClass('psp-info-done')) {
    //     def.load(Handlebars.templates['pcg.productinfo'], $(".mse-psp-info"), () => {
    //         productinfo.load(() => { $(".mse-psp-info").addClass('psp-info-done'); });
    //     });
    // }
}
catch (e) {
}
if (typeof window['ds_warranties'] == 'undefined') {
    window['ds_warranties'] = null;
}
if (ds_getcontent && ds_getcontent.Files) {
    var rename = function (str) {
        if (str && typeof (str) == "string" && str.length > 0) {
            str = str.toLowerCase();
            str = str.substring(0, 1).toUpperCase() + str.substring(1);
        }
        return str;
    };
    for (var i = 0; i < ds_getcontent.Files.length; i++) {
        var item = ds_getcontent.Files[i];
        item.Priority = rename(item.Priority);
    }
}
downloadDetail.Render(ds_getcontent);
$(function () {
    var mt = $("#divauto-tranmt").data("mt");
    if (mt) {
        window["lmd"]["machinetranslated"] = mt;
    }
    $("#dl_FullApiPath").val(l.UrlUtility.getFullServicesPath('/Product/'));
    $(document).ready(function () {
        $('.opeselectproductbot').change(function () {
            if ($(this).val() != "") {
                $(".pselectvlue").html($(this).find("option:selected").text());
                $('.opeselectproduct').val($(this).val());
            }
            else {
                $(".pselectvlue").html($(this).find("option:selected").text());
                $('.opeselectproduct').val("");
            }
            $('.opeselectproduct').each(function () {
                var owidth = $(this).parent().prev().css('width');
                $(this).css('width', owidth);
                $(this).parent().css('width', owidth);
            });
            //try {
            //    if ($("#selectcontentid") != undefined && $("#selectcontentid") != null)
            //    {
            //        $("#selectcontentid").width($("#selectcontentid").width() + 20);
            //    }
            //}
            //catch (e)
            //{ }
            try {
                var owidthbottop = $("#parent_fastsearch").css('width');
                var owidthbotspantop = $("#topsearchshowspancommon").css('width');
                if (owidthbottop != undefined && owidthbottop != null && owidthbotspantop != undefined && owidthbotspantop) {
                    $("#searchinputtop").css('width', ((parseInt(owidthbottop.substring(0, owidthbottop.toLowerCase().lastIndexOf("p")))) - (parseInt(owidthbotspantop.substring(0, owidthbotspantop.toLowerCase().lastIndexOf("p")))) - 28).toString() + "px");
                }
            }
            catch (e) { }
            try {
                var owidthbot = $("#searchcontentinputdiv").css('width');
                var owidthbotspan = $("#searchcontentinputdivspan").css('width');
                if (owidthbot != undefined && owidthbot != null && owidthbotspan != undefined && owidthbotspan) {
                    $("#searchcontentinput").css('width', ((parseInt(owidthbot.substring(0, owidthbot.toLowerCase().lastIndexOf("p")))) - (parseInt(owidthbotspan.substring(0, owidthbotspan.toLowerCase().lastIndexOf("p")))) - 75).toString() + "px");
                }
            }
            catch (e) { }
            try {
                var textinput = $("#searchcontentinput").val();
                if (textinput != undefined && textinput != null) {
                    if (textinput != "") {
                        var strpdtgroup = "";
                        if ($(this).val() != "") {
                            var _productsort = $(this).val();
                            try {
                                if (_productsort != undefined && _productsort != null && _productsort != "") {
                                    strpdtgroup = "&ProductGroup=" + _productsort;
                                }
                            }
                            catch (e) { }
                        }
                        try {
                            if (window['config'] && window['config'].product) {
                                strpdtgroup = strpdtgroup + "&Products=" + window['config'].product.ID;
                            }
                        }
                        catch (e) { }
                        window.location.href = l.UrlUtility.getFullPath("/search?query=" + textinput + strpdtgroup + "&searchLocation=bottom_S");
                    }
                }
            }
            catch (e) {
            }
        });
        try {
            var tempselectgroupurl = GeturlQueryString("ProductGroup");
            $('.opeselectproduct').val(tempselectgroupurl);
            $(".pselectvlue").html($(".opeselectproduct").first().find("option:selected").text());
        }
        catch (e) {
        }
        $('.opeselectproduct').each(function () {
            var owidth = $(this).parent().prev().css('width');
            $(this).css('width', owidth);
            $(this).parent().css('width', owidth);
        });
        //try {
        //    if ($("#selectcontentid") != undefined && $("#selectcontentid") != null) {
        //        $("#selectcontentid").width($("#selectcontentid").width() + 20);
        //    }
        //}
        //catch (e)
        //{ }
        try {
            var owidthbottop = $("#parent_fastsearch").css('width');
            var owidthbotspantop = $("#topsearchshowspancommon").css('width');
            if (owidthbottop != undefined && owidthbottop != null && owidthbotspantop != undefined && owidthbotspantop) {
                $("#searchinputtop").css('width', ((parseInt(owidthbottop.substring(0, owidthbottop.toLowerCase().lastIndexOf("p")))) - (parseInt(owidthbotspantop.substring(0, owidthbotspantop.toLowerCase().lastIndexOf("p")))) - 28).toString() + "px");
            }
        }
        catch (e) { }
        try {
            var owidthbot = $("#searchcontentinputdiv").css('width');
            var owidthbotspan = $("#searchcontentinputdivspan").css('width');
            if (owidthbot != undefined && owidthbot != null && owidthbotspan != undefined && owidthbotspan) {
                $("#searchcontentinput").css('width', ((parseInt(owidthbot.substring(0, owidthbot.toLowerCase().lastIndexOf("p")))) - (parseInt(owidthbotspan.substring(0, owidthbotspan.toLowerCase().lastIndexOf("p")))) - 75).toString() + "px");
            }
        }
        catch (e) { }
        try {
            $(window).resize(function () {
                try {
                    var owidthbottop = $("#parent_fastsearch").css('width');
                    var owidthbotspantop = $("#topoperspanid").css('width');
                    if (owidthbottop != undefined && owidthbottop != null && owidthbotspantop != undefined && owidthbotspantop) {
                        $("#searchinputtop").css('width', ((parseInt(owidthbottop.substring(0, owidthbottop.toLowerCase().lastIndexOf("p")))) - (parseInt(owidthbotspantop.substring(0, owidthbotspantop.toLowerCase().lastIndexOf("p")))) - 28).toString() + "px");
                    }
                }
                catch (e) { }
                try {
                    var owidthbot = $("#searchcontentinputdiv").css('width');
                    var owidthbotspan = $("#searchcontentinputdivspan").css('width');
                    if (owidthbot != undefined && owidthbot != null && owidthbotspan != undefined && owidthbotspan) {
                        $("#searchcontentinput").css('width', ((parseInt(owidthbot.substring(0, owidthbot.toLowerCase().lastIndexOf("p")))) - (parseInt(owidthbotspan.substring(0, owidthbotspan.toLowerCase().lastIndexOf("p")))) - 75).toString() + "px");
                    }
                }
                catch (e) { }
            });
        }
        catch (e) { }
        //lpdt--start
        try {
            if (ds_getcontent != undefined && ds_getcontent != null) {
                if (ds_getcontent.Type == "LPDT") {
                    var str = "";
                    if (ds_getcontent.QUESTION_TYPE == '1') {
                        str += "<div >";
                        if (ds_getcontent.Responses != undefined && ds_getcontent.Responses != null) {
                            for (var key in ds_getcontent.Responses) {
                                //
                                str += "<input class=\"pdt_btn lpdtclickOfLPDT\" type=\"button\"  value=\"" + ds_getcontent.Responses[key].Text + "\" data-lpdtvlue=\"" + key + "\"  />";
                            }
                        }
                        str += "</div>";
                    }
                    else {
                        str += " <ul class=\"pdt_ul\" >";
                        if (ds_getcontent.Responses != undefined && ds_getcontent.Responses != null) {
                            for (var key in ds_getcontent.Responses) {
                                str += " <li ><a class=\"lpdtclickOfLPDT\"  data-lpdtvlue=\"" + key + "\" href=\"javascript:void(0);\"><span>" + ds_getcontent.Responses[key].Text + "</span></a></li>";
                            }
                        }
                        str += " </ul>";
                    }
                    $("#lpdtcontentdetail").html(str);
                    $("#LPDTCONTENT").show();
                    $('#btn_previousstep').on('click', function () {
                        window.history.go(-1);
                    });
                    $('.lpdtclickOfLPDT').click(function () {
                        clickOfLPDT($(this).attr("data-lpdtvlue"));
                    });
                    if (ds_getcontent.IsFirst) {
                        $('#btn_previousstep').hide();
                    }
                }
                else {
                    $("#LPDTCONTENT").hide();
                }
            }
        }
        catch (e) {
        }
        //lpdt--end
        //try {
        //    if (history.length > 1) {
        //        $(".psp-content-back").show();
        //    }
        //}
        //catch (e) {
        //    $(".psp-content-back").show();
        //}
    });
    if (window["LoadSearchBarWrapper"] != undefined) {
        var loadsearchbar = window["LoadSearchBarWrapper"];
        loadsearchbar(document.getElementsByClassName('detailpage-searchbar-app')[0], { placement: 'inpage' });
    }
    $('#searchcontentinput').keyup(function (e) {
        if (e.which === 13) {
            var strpdtgroup = "";
            if ($(this).val() != "") {
                try {
                    var _productsort = $("#selectcontentid").val();
                    if (_productsort != undefined && _productsort != null && _productsort != "") {
                        strpdtgroup = "&ProductGroup=" + _productsort;
                    }
                }
                catch (e) { }
                goSearch(encodeURIComponent($(this).val()) + strpdtgroup + "&searchLocation=bottom_S");
            }
        }
    });
    $('#searchcontentiocn').on('click', function () {
        var strpdtgroup = "";
        if ($('#searchcontentinput').val() != "") {
            try {
                var _productsort = $("#selectcontentid").val();
                if (_productsort != undefined && _productsort != null && _productsort != "") {
                    strpdtgroup = "&ProductGroup=" + _productsort;
                }
            }
            catch (e) { }
            goSearch(encodeURIComponent($('#searchcontentinput').val()) + strpdtgroup + "&searchLocation=bottom_S");
        }
    });
});
var expiredTipsTime = 30;
var ExpiredMessage = function () {
    var alertTime = expiredTipsTime * 60 * 1000;
    console.log("ExpiredMessage Times is :" + alertTime);
    setTimeout(function () {
        common_1.Utils.showExpiredTips(function () {
            window.location.href = window.location.href;
        });
    }, alertTime);
};
$(window).on("load", function () {
    try {
        if (ds_getcontent != undefined && ds_getcontent != null) {
            if (ds_getcontent.expiredTime) {
                expiredTipsTime = parseFloat(ds_getcontent.expiredTime);
                if (expiredTipsTime >= 10) {
                    expiredTipsTime = expiredTipsTime - 1;
                }
            }
            if ((ds_getcontent.RequireLogin) && l.AccountAuthentication.isLogin()) {
                ExpiredMessage();
            }
            if (ds_getcontent.PNCheck) {
                if (Cookies.get("PNIsNormal")) {
                    var pncheckresult = Cookies.get("PNIsNormal");
                    var getSnAndPnCheck = decodeURIComponent(escape(window.atob(pncheckresult)));
                    var checkSn = getSnAndPnCheck.split('|')[0];
                    var checkPnResult = getSnAndPnCheck.split('|')[1];
                    var currentsn = window["config"] && window["config"].product && window["config"].product.Serial ? window["config"].product.Serial : "";
                    if (currentsn.toUpperCase() == checkSn.toUpperCase() && checkPnResult == "true") {
                        ExpiredMessage();
                    }
                }
            }
        }
    }
    catch (error) {
        console.log("ds_getcontent have a error:" + error);
    }
});
var goSearch = function (qString) {
    if (qString) {
        //solr.load(qString);
        var q = "";
        var type = l.UrlUtility.getUrlParam('type', false);
        if (type) {
            q = q + "&type=" + type;
        }
        var Products = l.UrlUtility.getUrlParam('Products', false);
        if (Products) {
            q = q + "&Products=" + Products;
        }
        else {
            try {
                if (window['config'] && window['config'].product) {
                    q = q + "&Products=" + window['config'].product.ID;
                }
            }
            catch (e) { }
        }
        //var baseUrl = l.UrlUtility.getLocationOrigin() + window.location.pathname;
        window.location.href = l.UrlUtility.getFullPath("/search?query=" + qString + q);
        //l.UrlUtility.changeURL($(document).find("title").text(), baseUrl + "?query=" + qString + q);
    }
};
function GeturlQueryString(name) {
    try {
        return l.UrlUtility.getUrlParam(name, true);
    }
    catch (e) {
        return "";
    }
}
function clickOfLPDT(key) {
    try {
        var event = ds_getcontent.Responses[key];
        if (event.Value == "") {
            return;
        }
        if (event.Type == 8) {
            $("#dowContentName").hide();
            $("#lpdtcontentdetail").hide();
            $("#contentBody").html(event.Value);
            $("#psp-content-detail-lpdt-button").hide();
            try {
                scroll(0, 0);
            }
            catch (e) { }
            return false;
        }
        else if (event.Type == 16) {
            if (event.Value == '')
                return false;
            window.location.href = event.Value;
        }
        else {
            var href = "";
            var pathname = window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/') + 1) + event.Value;
            if (event.Type == 4) {
                href = geturl('KB', event.Value);
            }
            else {
                href = geturl('LPDT', event.Value);
            }
            window.location.href = href + window.location.search;
        }
    }
    catch (e) {
    }
}
function geturl(type, id) {
    var url = "";
    switch (type) {
        case "AccessoryInfo":
            url = l.UrlUtility.getFullPath("/accessories/" + id);
            break;
        case "Driver":
            url = l.UrlUtility.getFullPath("/downloads/" + id);
            break;
        case "Driver.File":
            url = id;
            break;
        case "KB":
            url = l.UrlUtility.getFullPath("/solutions/" + id);
            break;
        case "MSH":
            url = l.UrlUtility.getFullPath("/solutions/" + id);
            break;
        case "TS":
            url = l.UrlUtility.getFullPath("/solutions/" + id);
            break;
        case "PS":
            url = l.UrlUtility.getFullPath("/product_security/" + id);
            break;
        case "Lithium.KB":
            url = l.UrlUtility.getFullPath("/forumkb/" + id.replace(/\|/g, "!!"));
            break;
        case "Lithium.Solution":
            l.UrlUtility.getFullPath(url = "/forumsolution/" + id.replace(/\|/g, "!!"));
            break;
        case "Manual":
            url = l.UrlUtility.getFullPath("/manuals/" + id);
            break;
        case "Manual.File":
            url = id;
            break;
        case "PartInfo":
            url = l.UrlUtility.getFullPath("/parts/" + id);
            break;
        case "ProductInfo":
            url = l.UrlUtility.getFullPath("/documents/" + id);
            break;
        case "URL":
            url = id;
            break;
        case "Spider":
            url = id;
            break;
        case "Video":
            url = l.UrlUtility.getFullPath("/videos/" + id);
            break;
        case "Product":
            url = l.UrlUtility.getFullPath("/products/" + id);
            break;
        case "LPDT":
            url = l.UrlUtility.getFullPath("/troubleshoot/" + id);
            break;
    }
    return url;
}
